import {applicationKeyPrefix} from 'modules/app/constants';

const apiKey = 'uniportal.apiToken';
const oauth2Key = 'uniportal.oauth2Token';
const refreshKey = 'uniportal.refreshToken';

const passwordResetIdKey = 'uniportal.passwordResetId';

const authRedirectUsername = 'uniportal.authRedirect.username';
const authRedirectData = 'uniportal.authRedirect.data';

const rememberedLocation = 'uniportal.rememberLocation';
const currentUsernameKey = 'uniportal.username';

const getApplicationTokenKey = application => applicationKeyPrefix + application + '.token';

export const getApiToken = () => getLocalToken(apiKey);
export const getApplicationToken = (application) => getSessionToken(getApplicationTokenKey(application));
export const getOAuth2Token = () => getLocalToken(oauth2Key);
export const getRefreshToken = () => getLocalToken(refreshKey);

export const getPasswordResetId = () => getLocalToken(passwordResetIdKey);

const getLocalToken = (tokenKey) => getToken(localStorage, tokenKey);
const getSessionToken = (tokenKey) => getToken(sessionStorage, tokenKey);

const getToken = (storage, tokenKey) => {
    let tokenData = storage.getItem(tokenKey);

    if (!tokenData) {
        return null;
    }
    tokenData = JSON.parse(tokenData);

    return tokenData.token || null;
};

export const setApiToken = (token, expiry) => setLocalToken(apiKey, token, expiry);
export const setApplicationToken = (application, token, expiry) => setSessionToken(getApplicationTokenKey(application), token, expiry);
export const setOAuth2Token = (token, expiry) => setLocalToken(oauth2Key, token, expiry);
export const setRefreshToken = (token, expiry) => setLocalToken(refreshKey, token, expiry);

export const setPasswordResetId = resetId => setLocalToken(passwordResetIdKey, resetId, 3600)

const setLocalToken = (tokenKey, token, expiry) => setToken(localStorage, tokenKey, token, expiry);
const setSessionToken = (tokenKey, token, expiry) => setToken(sessionStorage, tokenKey, token, expiry);

const setToken = (storage, tokenKey, token, expiry) => {
    storage.setItem(tokenKey, JSON.stringify({token, expiry}));
};

export const getAuthRedirectDetails = () => {

    const data = JSON.parse(localStorage.getItem(authRedirectData));
    data.username = localStorage.getItem(authRedirectUsername);

    return data;
};

export const setAuthRedirectDetails = (username, domain, clientId, identityProvider) => {
    localStorage.setItem(authRedirectUsername, username);
    localStorage.setItem(authRedirectData, JSON.stringify({domain, clientId, identityProvider}));
};

export const getCurrentUsername = () => localStorage.getItem(currentUsernameKey) || '';
export const setCurrentUsername = (username) => localStorage.setItem(currentUsernameKey, username);

export const rememberLocation = location => {
    localStorage.setItem(rememberedLocation, location);
};

export const recallLocation = () => {
    const location = localStorage.getItem(rememberedLocation);
    localStorage.removeItem(rememberedLocation);
    return location;
}

export const clearTokensAndData = () => {
    localStorage.removeItem(apiKey);
    localStorage.removeItem(oauth2Key);
    localStorage.removeItem(refreshKey);
    localStorage.removeItem(authRedirectData);
    localStorage.removeItem(authRedirectUsername);
    localStorage.removeItem(currentUsernameKey);
    sessionStorage.clear();
};

export const clearPasswordResetData = () => {
    localStorage.removeItem(passwordResetIdKey);
}

const specialChars = '-!@#$%^&*_'

export const passwordRequirementMessages = {
    lower: "Must contain at least one lowercase letter.",
    upper: "Must contain at least one uppercase letter.",
    number: "Must contain at least one number.",
    special: "Must contain at least one special character: " + specialChars,
    length: "Must be at least 12 characters long."
};

export const validatePassword = password => {
    const results = {
        lower: false,
        upper: false,
        number: false,
        special: false,
        length: false,
    };

    const testMap = {
        lower: /[a-z]+/,
        upper: /[A-Z]+/,
        number: /[0-9]+/,
        special: new RegExp('[' + specialChars + ']+'),
        length: /(.{12})+/,
    };

    Object.keys(testMap).forEach((test) => {
        results[test] = !!password.match(testMap[test]);
    });

    return {
        valid: Object.values(results).reduce((valid, result) => valid && result, true),
        tests: results,
    };
};